module.exports = __webpack_public_path__ + "/images/cover-embarazada-posando-@2x.a8a0ccd.jpg";